export function getNavigationId(title: string | null): string | undefined {
  if (!title || title.length === 0) {
    return undefined;
  }

  return title.replace(' ', '-').toLowerCase();
}
